// @flow
import React, { Component, Fragment, Suspense } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { hasPrincipal } from "../../../global/containers/UserAuth";
import SoftwareItem from "../../components/softwares/SoftwareItem";
import {
  fetchSoftwares,
  getDownloadLinkUrl
} from "../../actions/softwareActions";
import {
  LoadingProgress,
  AppHeader,
  GeneralModalForm
} from "imagus-components";
import { getSoftwareJson } from "../../components/softwares/buildSoftwareJson";
import GetDownloadLinkForm from "../../components/softwares/GetDownloadLinkForm";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography
} from "@material-ui/core";
import { ExpandMore, FiberNew as NewIcon } from "@material-ui/icons";

/** Change this const to display "new" tag next to name */
const LATEST_ORDER = 4;

class MySoftwares extends Component<*> {
  constructor(props: *) {
    super(props);
    this.state = {
      linkModal: false
    };
  }

  componentDidMount() {
    this.props.actions.fetchSoftwares();
  }

  switchModalStatus =
    (modalName: string): * =>
    (status: boolean): * => {
      this.setState({ [modalName]: status });
    };

  downloadFile = (
    softwareId: string,
    versionId: string,
    days?: number,
    doneCall?: Function
  ): * => {
    this.props.actions.getDownloadLinkUrl(
      softwareId,
      versionId,
      days,
      (url: string): * =>
        doneCall ? doneCall(url) : (window.location.href = url),
      undefined
    );
  };

  render(): * {
    const isAdmin = hasPrincipal("imagus_admin", this.props.user.groups);
    const isBetaUser = hasPrincipal(
      "beta_software_user",
      this.props.user.groups
    );
    const softwares = this.props.softwares;

    let contentBlock = null;
    let linkList = [];

    if (!softwares) {
      contentBlock = <LoadingProgress />;
    } else {
      contentBlock = (
        <Grid item xs={12}>
          {softwares.map((software: *, i: number): * => {
            let item = getSoftwareJson(software, isAdmin);
            return (
              <ExpansionPanel key={software.name + "-" + i}>
                <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                  <Typography
                    variant="subtitle1"
                    className="heading"
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    {software.name}{" "}
                    {software.orderId === LATEST_ORDER && (
                      <NewIcon
                        className="shine-icon"
                        style={{ marginLeft: "10px" }}
                      />
                    )}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Suspense failback={<LoadingProgress />}>
                    <SoftwareItem
                      key={software.id}
                      software={item}
                      isAdmin={isAdmin}
                      isBetaUser={isBetaUser}
                      downloadFile={this.downloadFile}
                    />
                  </Suspense>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            );
          })}
        </Grid>
      );

      softwares.map((software: *): * => {
        let item = getSoftwareJson(software, isAdmin);
        linkList.push({
          softwareId: item.id,
          versionId: item.currentVersion.versionId,
          name: item.name
        });
      });
    }

    return (
      <Fragment>
        <AppHeader
          title="Latest Download"
          IconName="GetApp"
          {...(isAdmin
            ? {
                actions: [
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    className="dark-btn"
                    onClick={(): Function =>
                      this.switchModalStatus("linkModal")(true)
                    }
                  >
                    <CloudDownloadIcon className="light-icon right-margin-5" />
                    Get Latest Links
                  </Button>
                ]
              }
            : {})}
        />
        <div className="app-panel">
          <div className="app-panel-content">
            <Grid container spacing={24}>
              {contentBlock}
            </Grid>
          </div>
        </div>
        <GeneralModalForm
          title="Get All Latest Download Links"
          open={this.state.linkModal}
          handleModalStatus={this.switchModalStatus("linkModal")}
          form={
            <GetDownloadLinkForm
              onClose={(): Function =>
                this.switchModalStatus("linkModal")(false)
              }
              downloadFile={this.downloadFile}
              linkList={linkList}
            />
          }
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  softwares: state.v3account.software.softwares,
  user: state.v3account.user
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetchSoftwares, getDownloadLinkUrl }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MySoftwares);
